export { default } from './Table';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Table/index.js
// module id = 359
// module chunks = 0